import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "../../assets/css/slider.css";
import { getAllProjects, getProjectById } from "../../service/MainService";
import noimg from "../../assets/images/noimg.webp";

const BannerCarousel = () => {
  const [slides, setSlides] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSlides = async () => {
      try {
        const data = await getAllProjects(0, 6, {});
        if (data && data.Result && data.Result.length > 0) {
          const allSlides = [];
          data.Result.forEach((project) => {
            const img =
              project.Image1
                ? project.Image1
                : project.ImageUrls && project.ImageUrls.length > 0
                ? project.ImageUrls[0]
                : noimg;
            allSlides.push({
              img: img,
              title: project.ProjectName,
              subtitle: project?.Country?.countryName || "",
              projectId: project.ProjectId,
            });
          });
          setSlides(allSlides);
        }
      } catch (err) {
        console.error("BannerCarousel: failed to load projects", err);
      }
    };
    fetchSlides();
  }, []);

  const handleSlideClick = async (projectId) => {
    try {
      const token = localStorage.getItem("accessToken");
      const projectDetails = await getProjectById(projectId, token);
      navigate(`/project/${projectId}`, {
        state: { projectDetails },
      });
    } catch (error) {
      console.error("Error navigating to project:", error);
    }
  };

  if (slides.length === 0) return null;

  return (
    <div className="mt-5">
      <Swiper
        spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        breakpoints={{
          640: { slidesPerView: 1, spaceBetween: 20 },
          768: { slidesPerView: 1, spaceBetween: 20 },
          1024: { slidesPerView: 1, spaceBetween: 20 },
        }}
        className="mySwiper"
        modules={[Autoplay, Pagination, Navigation]}
      >
        {slides.map((slide, index) => (
          <SwiperSlide
            key={index}
            className="mb-10 relative cursor-pointer"
            style={{ width: "100%", height: "500px" }}
            onClick={() => handleSlideClick(slide.projectId)}
          >
            <img
              src={slide.img}
              alt={slide.title || `Slide ${index + 1}`}
              className="w-full h-full object-cover"
              onError={(e) => { e.target.src = noimg; }}
            />
            <div className="absolute inset-0 flex flex-col items-center justify-end pb-10 opacity-100 transition-opacity duration-300 bg-black bg-opacity-40 text-white hover:bg-opacity-30">
              <div className="text-center">
                <h2 className="text-xl sm:text-2xl font-bold">{slide.title}</h2>
                <p className="text-sm sm:text-base">{slide.subtitle}</p>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default BannerCarousel;
